export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--warning--red-v2.49760dd6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};